import React, { useEffect } from 'react';

import './App.css';
import { ZoomMtg } from '@zoom/meetingsdk';
import { jwtDecode } from "jwt-decode";

export const baseUrlDashboard = process.env.REACT_APP_NODE_BACKEND_DASHBOARD_URL;

ZoomMtg.preLoadWasm();
ZoomMtg.prepareWebSDK();

function App() {
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get("token");
  const accessToken = queryParameters.get("accessToken");

  function startMeeting(meetingNumber, passWord, userName, userEmail, sdkKey, signature, zak, customerKey) {
    document.getElementById('zmmtg-root').style.display = 'block'

    ZoomMtg.init({
      leaveUrl: `${window.location.origin}/session-ended`,
      patchJsMedia: true,
      success: (success) => {

        ZoomMtg.join({
          signature,
          sdkKey,
          meetingNumber,
          passWord,
          userName,
          userEmail,
          tk: '',
          zak,
          customerKey,
          success: (success) => {
            console.log('joined successfullly')
            fetch(`${baseUrlDashboard}/student/attendance`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}` // Authorization header with Bearer token
              },
              body: JSON.stringify({
                data: success,
                meetingId: meetingNumber
              })
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error('API response was not OK');
                }
                return response.json();
              })
              .then((data) => {
                console.log('API Response:', data);
              })
              .catch((error) => {
                console.error('API Error:', error);
              });
            fetch(`${baseUrlDashboard}/zoom/check-and-end-old-meeting/${meetingNumber}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}` // Authorization header with Bearer token
              },
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error('API response was not OK');
                }
                return response.json();
              })
              .then((data) => {
                console.log('API Response:', data);
              })
              .catch((error) => {
                console.error('API Error:', error);
              });
          },
          error: (error) => {
            console.log('error join on meeting', error)
          }
        })

      },
      error: (error) => {
        console.log(error)
      }
    })
  }

  useEffect(() => {
    async function getSignature() {
      // e.preventDefault();
      const { meetingNumber, passWord, userName, userEmail, sdkKey, signature, zakToken: zak, customerKey, role } = await jwtDecode(token)
      startMeeting(meetingNumber, passWord, userName, userEmail, sdkKey, signature, zak, customerKey)
    }
    getSignature();
  }, [token])

  return (
    <div className="App">
      <main />
    </div>
  );
}

export default App;
